var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"howtouse"},[_c('div',{staticClass:"container py-5"},[(_vm.setting.appId == 'default')?_c('Howtouse_default'):_vm._e(),(_vm.setting.appId == 'boston')?_c('Howtouse_boston'):_vm._e(),(_vm.setting.appId == 'eisai')?_c('Howtouse_eisai'):_vm._e()],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }